module.exports = "/_next/static/images/why-pto-92484dfa2af6f111a762bed77dbc94e3.jpg";